import {
  EntityIconBase,
  type EntityIconAppearance,
  type EntityIconDensity,
} from './entity-icon-base';
import { Alert01Icon } from '@terra/ui-icons';

type IconFindingProps = {
  appearance?: EntityIconAppearance;
  density?: EntityIconDensity;
};

export function IconFinding({ appearance, density }: IconFindingProps) {
  return (
    <EntityIconBase
      icon={Alert01Icon}
      bg="bg.entity.finding"
      color="fg.entity.finding"
      borderColor="border.entity.finding"
      appearance={appearance}
      density={density}
    />
  );
}
